"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const Attendee_1 = require("../Protocol/Attendee");
const SessionDefinition_1 = require("../SessionDefinition");
const SessionTicket_1 = require("../Protocol/SessionTicket");
const Session_1 = require("../Session");
const ISessionFactory_1 = require("../ISessionFactory");
class SessionFactory {
    constructor(isService, sessionRepo, langyan, cmdHub, evtHub) {
        this._isService = false;
        this._sessionRepo = sessionRepo;
        this._langyan = langyan;
        this._commandHub = cmdHub;
        this._eventHub = evtHub;
    }
    CreateNewSessionByCreator(sessionType, creator, needRecord = false, attendees) {
        const sessionTicket = SessionTicket_1.SessionTicket.Builder()
            .AutoId()
            .Type(sessionType)
            .Creator(creator)
            .NeedRecord(needRecord)
            .Build();
        const allAttendee = immutable_1.List(attendees).push(creator.toAttendee());
        return this.CreateNewSession(sessionTicket, allAttendee.toArray());
    }
    CreateNewSession(sessionTicket, attendees) {
        if (sessionTicket.type === SessionDefinition_1.SessionType.Unknown)
            throw new ISessionFactory_1.SessionFactoryError(`sessionTicket should not be ${SessionDefinition_1.SessionType.Unknown}`);
        if (sessionTicket.creator === Attendee_1.Creator.Nobody)
            throw new ISessionFactory_1.SessionFactoryError(`Creator should not be Nobody`);
        //if (!this._langyan.isConnected()) throw new SessionFactoryError(`langyan is not connected.`);
        return new Session_1.Session(this._isService, this._sessionRepo, this._langyan, this._commandHub, this._eventHub, {
            id: sessionTicket.id,
            Type: sessionTicket.type,
            Status: SessionDefinition_1.Status.Created,
            Creator: sessionTicket.creator,
            Attendees: new Set(attendees),
            NeedRecord: sessionTicket.needRecord,
            CreatedFrom: new Date(),
        });
    }
    IsService() {
        return true;
    }
}
exports.SessionFactory = SessionFactory;
//# sourceMappingURL=SessionFactory.js.map